import { createSlice } from '@reduxjs/toolkit';

export const dialog = createSlice({
  name: 'dialog',
  initialState: {
    isShowing: false,
    options: {
      isAlert: false,
      message: '',
      textCenter: '',
    },
  },
  reducers: {
    setDialog: (state, action) => {
      state.isShowing = action.payload;
    },
    setOptions: (state, action) => {
      state.options = action.payload;
    },
  },
});

export const { setDialog, setOptions } = dialog.actions;

export const selectIsShowing = (state) => state.dialog.isShowing;
export const selectOptions = (state) => state.dialog.options;

export default dialog.reducer;
